module.exports = __webpack_public_path__ + "static/media/sparkles.0b396210.svg";